<div>{{label}}</div>
<small>{{type}}</small>
